import { createSelector } from 'reselect';

import { AppState } from '../../../../../store/models/app-state';

const headerBannerListState = (state: AppState) => state.contentManagement.headerBanner.headerBannerList;

export const headerBannerListItemsSelector = createSelector(headerBannerListState, state => {
    const headerBannerItems = state.items;
    return {
        ...headerBannerItems,
        items: headerBannerItems.items.map(item => ({
            ...item,
            previewImage: item.image['221x48'],
        })),
    };
});
export const headerBannerListRequestingSelector = createSelector(headerBannerListState, state => state.requesting);
